<!-- Thanks to https://codepen.io/melnik909/pen/qPjwvq -->


<div [ngClass]="['timeline']">
  <div [ngClass]="['timeline__group']" *ngFor="let group of this.timelineGroups">
    <span *ngIf="group.timelineYear !== null" [ngClass]="['timeline__year']">{{group.timelineYear}}</span>
    <div [ngClass]="['timeline__box', item.timelinePosts?.length === 0 ? 'timeline__box_no_line' : '']" *ngFor="let item of group?.timelineItems">

      <div [ngClass]="['timeline__date']" *ngFor="let date of item?.timelineDates" (click)="routeClicked(item)">
        <span [ngClass]="['timeline__day']" *ngFor="let day of date?.timelineDays" [innerHtml]="day"></span>
        <span [ngClass]="['timeline__month']" *ngFor="let month of date?.timelineMonths" [innerHtml]="month"></span>
      </div>
      <div [ngClass]="[item.timelinePosts?.length > 0 ?'timeline__post' : 'timeline__post_hidden']">
        <div [ngClass]="['timeline__content']" *ngFor="let post of item?.timelinePosts">

            <div [ngClass]="['row']" *ngIf="post.postTitle !== undefined">
                <div [ngClass]="['col']">
                  <span [ngClass]="['timeline__post_title']">{{post.postTitle}}</span>
                </div>
              </div>
            <div [ngClass]="['row']">
              <div [ngClass]="['col']" [innerHtml]="post.contentInnerHTML" ></div>
            </div>

        </div>


      </div>
    </div>

  </div>
</div>